import { InjectionToken } from "@angular/core";
import { AutoBonusSummaryPort } from "./auto-bonus-summary.port";

export const AUTO_BONUS_SUMMARY_PORT =
  new InjectionToken<AutoBonusSummaryPort>("AUTO_BONUS_SUMMARY_PORT");
